import { render, staticRenderFns } from "./WeekendSessionAlerts.vue?vue&type=template&id=32ca8867&scoped=true&"
import script from "./WeekendSessionAlerts.vue?vue&type=script&lang=js&"
export * from "./WeekendSessionAlerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ca8867",
  null
  
)

export default component.exports